import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '@components/MetricCard';
import { OrganizationProfile } from '../types';

interface OrganizationMetricsProps {
  profile: OrganizationProfile;
}

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
};

export const OrganizationMetricsComponent: React.FC<OrganizationMetricsProps> = ({ profile }) => {
  const { t } = useTranslation();

  const metricCards = [
    {
      title: t('organization.metrics.totalUsers'),
      value: profile.total_users,
      icon: 'people',
      variant: 'primary' as const,
      trend: t('organization.metrics.thisMonth'),
      trendType: 'neutral' as const,
    },
    {
      title: t('organization.metrics.activeUsers'),
      value: profile.active_users,
      icon: 'check_circle',
      variant: 'success' as const,
      trend: t('organization.metrics.thisMonth'),
      trendType: 'neutral' as const,
    },
    {
      title: t('organization.metrics.aiAgents'),
      value: profile.ai_agents,
      icon: 'smart_toy',
      variant: 'info' as const,
      trend: t('organization.metrics.thisMonth'),
      trendType: 'neutral' as const,
    },
    {
      title: t('organization.metrics.monthlyUsage'),
      value: formatCurrency(profile.monthly_usage),
      icon: 'attach_money',
      variant: 'warning' as const,
      trend: t('organization.metrics.thisMonthPercent'),
      trendType: 'neutral' as const,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricCards.map((card, index) => (
        <MetricCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          variant={card.variant}
          trend={card.trend}
          trendType={card.trendType}
        />
      ))}
    </div>
  );
};
